declare var window: any;
const configFunc = {
    HttpEndpoint: (path: any) => `${window.SCHEMA}://${window.ENDPOINT}${path}`,
    SocketEndpoint: (path: any) => `${window.WEBSOCKET_SCHEMA}://${window.ENDPOINT}${path}`
}

export default configFunc